<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" :loading="loading"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('journeysByStopMunicipalitiesReport.title') }}</h2>
      <p class="text-center mb-3 no-print">
        {{ $t('journeysByStopMunicipalitiesReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope" class="row">
      <div class="col-6">
        <card :title="$t('journeysByStopMunicipalitiesReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('journeysByStopMunicipalitiesReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.generatedAt | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('journeysByStopMunicipalitiesReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.periodFrom | dateOnly }} - {{
                  reportEnvelope.periodTo | dateOnly
                }}</h5></td>
            </tr>
            <!--            <tr>-->
            <!--              <td><h5 class="p-0 m-1">{{ $t('journeysByStopMunicipalitiesReport.summary.totalCharge') }}:</h5></td>-->
            <!--              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.totalCharge | money }}</h5></td>-->
            <!--            </tr>-->
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('journeysByStopMunicipalitiesReport.summary.totalJourneysCount') }}:</h5>
              </td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.totalJourneysCount }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>


    <div v-if="loading === false && !error && reportData" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t('journeysByStopMunicipalitiesReport.tableTitle') }}<small
            v-if="reportEnvelope"
            class="ml-2 text-muted">({{
              reportEnvelope.periodFrom | dateOnly
            }} - {{ reportEnvelope.periodTo | dateOnly }})</small>
          </h4>
          <div>
            <el-table :data="reportData"
                      :empty-text="$t('generic.emptyReportForThePeriod')">
              <el-table-column :label="$t('journeysByStopMunicipalitiesReport.table.municipality_id')">
                <template slot-scope="{ row }">
                  {{ row.municipality_id ? row.municipality_id : $t('journeysByStopMunicipalitiesReport.municipalityIdUnknown') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('journeysByStopMunicipalitiesReport.table.municipality_name')">
                <template slot-scope="{ row }">{{
                    row.municipality_name != "" ? row.municipality_name : $t('journeysByStopMunicipalitiesReport.municipalityNameUndefined')
                  }}
                </template>
              </el-table-column>
              <!--              <el-table-column :label="$t('journeysByStopMunicipalitiesReport.table.charge_in_stops')">-->
              <!--                <template slot-scope="{ row }">{{ row.charge_in_stops | money }}</template>-->
              <!--              </el-table-column>-->
              <el-table-column :label="$t('journeysByStopMunicipalitiesReport.table.journeys_in_stops')">
                <template slot-scope="{ row }">{{ row.journeys_in_stops }}</template>
              </el-table-column>
            </el-table>
          </div>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert} from 'src/components';
import {mapActions, mapState} from "vuex";
import DetailedReportPeriod from 'src/components/DetailedReportPeriod/DetailedReportPeriod';
import ReportFilter from "./ReportFilter";

export default {
  name: 'journeysByStopMunicipalitiesReport',
  components: {
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DetailedReportPeriod,
    ReportFilter
  },
  data() {
    return {
      report: null, // Received report data.
      reportEnvelope: null,
      reportData: [],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.journeys_by_stop_municipalities_report.loading,
      error: state => state.journeys_by_stop_municipalities_report.error,
      data: state => state.journeys_by_stop_municipalities_report.data,
    }),
  },
  methods: {
    ...mapActions(['LoadJourneysByStopMunicipalitiesReport']),
    reloadReport(query) {
      this.LoadJourneysByStopMunicipalitiesReport(query);
    },
    prepareReportData(report) {
      if (!report) {
        this.reportData = null;
        this.reportEnvelope = null;
        return
      }

      this.reportEnvelope = {
        totalCharge: 0,
        totalJourneysCount: 0,
        periodFrom: report.from,
        periodTo: report.to,
        generatedAt: report.generated_at,
      },

        this.reportData = report.data

      this.reportEnvelope.totalCharge = this.reportData.reduce((r, d) => r + d.charge_in_stops, 0);
      this.reportEnvelope.totalJourneysCount = this.reportData.reduce((r, d) => r + d.journeys_in_stops, 0);
    }
  },
  mounted() {
    this.prepareReportData(this.data)
  },
  watch: {
    data(data) {
      this.prepareReportData(data)
    }
  }
};
</script>

